import { Account } from 'shared/types/account';

export const getAccountFullName = (account: Account | undefined) => {
  if (!account) {
    return '';
  }
  return `${account.firstName ?? ''}${
    account.lastName ? ` ${account.lastName}` : ''
  }`;
};

export const getAccountCountry = (account: Account | undefined) => {
  if (!account?.addresses?.length) {
    return '';
  }

  const defaultBillingAddress = account.addresses.find(
    (addr) => addr.isDefaultBillingAddress,
  );
  const firstAddress = account.addresses[0];
  const addressToUse = defaultBillingAddress ?? firstAddress;

  return addressToUse?.country ?? '';
};
